/*
 * Barra fija de "Agregar al carro" para móvil (snippets/sticky-atc.liquid).
 * Se muestra cuando el botón principal de compra queda por encima de la pantalla y se oculta
 * cuando vuelve a verse o cuando se pasa a desktop (>= 750px).
 */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.priceContainer = document.getElementById(`price-${this.sectionId}`);
        this.button = this.querySelector('.sticky-atc__button');
        this.priceEl = this.querySelector('.sticky-atc__price');
        this.variantEl = this.querySelector('.sticky-atc__variant');
        if (!this.mainButton) return;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.buttonAboveViewport = false;

        this.observer = new IntersectionObserver(([entry]) => {
          this.buttonAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggle();
        });
        this.observer.observe(this.mainButton);

        this.onMediaChange = () => this.toggle();
        this.mobileQuery.addEventListener('change', this.onMediaChange);

        // Estado del botón (agotado / no disponible / cargando) igual al del botón principal.
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });

        // El tema reemplaza el contenido de #price-… al cambiar de variante.
        if (this.priceContainer) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.priceContainer, { childList: true, subtree: true });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event.data && event.data.variant;
            if (variant && this.variantEl && !this.variantEl.hidden) this.variantEl.textContent = variant.title;
          });
        }

        this.syncButton();
        this.syncPrice();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.priceObserver) this.priceObserver.disconnect();
        if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.onMediaChange);
        if (this.unsubscribe) this.unsubscribe();
        this.setVisible(false);
      }

      toggle() {
        this.setVisible(this.mobileQuery.matches && this.buttonAboveViewport);
      }

      setVisible(visible) {
        this.hidden = false;
        this.classList.toggle('sticky-atc--visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.button.tabIndex = visible ? 0 : -1;

        const root = document.documentElement;
        if (visible) {
          root.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
          document.body.classList.add('sticky-atc-visible');
        } else {
          root.style.setProperty('--sticky-atc-height', '0px');
          document.body.classList.remove('sticky-atc-visible');
        }
      }

      syncButton() {
        this.button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        const label = this.mainButton.querySelector('span');
        if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();
      }

      syncPrice() {
        if (!this.priceContainer || !this.priceEl) return;
        const price = this.priceContainer.querySelector('.price');
        if (!price) return;
        const current = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        if (current && current.textContent.trim()) this.priceEl.textContent = current.textContent.trim();
      }
    }
  );
}
